var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

_global.SENTRY_RELEASE = {
  id: "e4a87fd0b5f41ae70d44c96257fa0e3df72923f2"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["butternutbox-frontend@butternut"] = {
  id: "e4a87fd0b5f41ae70d44c96257fa0e3df72923f2"
};